import Label from "../../../ui/components/Label/Label";

import useProductionStatuses from "../../hooks/useProductionStatuses";

export default function ProductionStatusLabel({ status, ...props }) {
	const statuses = useProductionStatuses();

	return <Label {...statuses[status]} {...props} />;
}
